import { AgentsSlice } from './types/AgentSliceType'
import { CAMPAIGN_TYPES_VALUES } from '../../../utils/CampaignTypes/CampaignTypesValues'
import { Status } from '../../types'

const formatCampaignType = (
	agent: { agent_id: string; agent_type: string; agent_first_sentence: string },
	label: string,
) => ({
	label,
	value: agent.agent_id,
	introSentence: agent.agent_first_sentence,
	isAgent: true,
})

export const pending = (state: AgentsSlice, key: keyof AgentsSlice) => {
	state[key].status = Status.PENDING
}

export const rejected = (state: AgentsSlice, key: keyof AgentsSlice) => {
	state[key].status = Status.REJECTED
}

export const loadCommonAgents = (state: AgentsSlice) => {
	state.commonAgents.data = CAMPAIGN_TYPES_VALUES
}

export const fulfilledLoadProviderAgents = (state: AgentsSlice, { payload }: any) => {
	const agents = payload.map((response: any) => response.value)
	state.providerAgents.data = agents.map((agent: any) => formatCampaignType(agent, agent.agent_type))
	state.providerAgents.status = Status.IDLE
}

export const fulfilledLoadCustomAgents = (state: AgentsSlice, { payload }: any) => {
	const { agents } = payload
	state.customAgents.status = Status.IDLE
	if (agents) {
		state.customAgents.data = agents.map((agent: any) =>
			formatCampaignType(agent, `Custom Agent: ${agent.agent_type}`),
		)
	}
}
